import React from 'react';
import lang from '../Lang/lang.json';
import Icons from '../../Containers/Icons';
import {Redirect, NavLink} from 'react-router-dom';

let AdminMenu = (props) => {
  let {language} = props;
  let viewp = () => {
    if (typeof window.orientation !== 'undefined') {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div id="admin-menu">
    {
      !props.loged
      ? <Redirect to="/" push={true}/>
      : null
    }
      <ul>
        <NavLink to="/home/admin/lang" onClick={() => props.changeScreen("LngCnf")}>
          <li>
            <span className="menu-icon">
              <Icons name="lang" />
            </span>
            <p>{lang.Menu.LngCnf[language]}</p>
          </li>
        </NavLink>
        <NavLink to="/home/admin/usr" >
          <li>
            <span className="menu-icon">
              <Icons name="usr" />
            </span>
            <p>{lang.Menu.UsrCnf[language]}</p>
          </li>
        </NavLink>
        <NavLink to="/home/admin/tabs" onClick={() => props.changeScreen("TabCnf")}>
          <li>
            <span className="menu-icon">
              <Icons name="tabcnf" />
            </span>
            <p>{lang.Menu.TabCnf[language]}</p>
          </li>
        </NavLink>
        <NavLink to="/home/admin/vis" onClick={() => props.changeScreen("PointCnf")}>
          <li>
            <span className="menu-icon">
              <Icons name="viscnf" />
            </span>
            <p>{lang.Menu.PointCnf[language]}</p>
          </li>
        </NavLink>
        <NavLink to="/home/admin/vis" onClick={() => props.logOut()}>
          <li>
            <span className="menu-icon">
              <Icons name="logout" />
            </span>
            <p>{lang.Menu.LogOut[language]}</p>
          </li>
        </NavLink>
        {
          !viewp()
          ? (
            <div id="backup_admin_menu">
              <NavLink to="/home/admin/backupbd" onClick={() => props.changeScreen("BackupBD")}>
                <li>
                  <span className="menu-icon">
                    <Icons name="viscnf" />
                  </span>
                  <p>{lang.Menu.BackupBD[language]}</p>
                </li>
              </NavLink>
              <NavLink to="/home/admin/backupimg" onClick={() => props.changeScreen("BackupImg")}>
                <li>
                  <span className="menu-icon">
                    <Icons name="viscnf" />
                  </span>
                  <p>{lang.Menu.BackupImg[language]}</p>
                </li>
              </NavLink>
            </div>
          )
          : null
        }
      </ul>
    </div>
  )
}

export default AdminMenu;


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminMenu.js